(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lt-mobile-order-link"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lt-mobile-order-link')) {
    customElements.define('lt-mobile-order-link', class extends HTMLElement {
      connectedCallback() {
        const form = document.getElementById(this.dataset.formId);
        if (!form || !('IntersectionObserver' in window)) return;
        this.observer = new IntersectionObserver(([entry]) => {
          this.hidden = entry.isIntersecting || entry.boundingClientRect.bottom >= 0;
        });
        this.observer.observe(form);
      }
      disconnectedCallback() {
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
